export default function validPhoneNumber() {
  'ngInject';

  return {
    require: 'ngModel',
    link($scope, $element, $attrs, $ctrl) {
      const isTypeValid = (x) => Math.floor(x) === x;

      $ctrl.$validators['valid-phone-number'] = (model, view) => {
        if (!view) {
          return true;
        }

        if (typeof view === 'string') {
          return !/[^/\d/\s()-]/.test(view);
        }

        const number = Number(view);
        return !Number.isNaN(number) && isTypeValid(number);
      };
    },
  };
}
